<template>
  <div>
    <div v-if="loading" class="overlay">
      <clip-loader />
    </div>

    <div style="outline: none" @keyup.enter="getResults(1)">
      <div class="filter-search-bar">
        <div class="row px-3">
          <v-select
            v-model="searchFields.patientsFilter"
            class="col-md-3 my-3"
            name="patientFilters"
            :options="patientSearchOptions.patientFilters"
            :reduce="(filter) => filter.value"
            label="text"
            :placeholder="trans('patient.patientsCaseFiltersPlaceholder')"
            @update:model-value="getResults(1)"
          >
            <template #option="option">
              <span :data-test="`patients-filter-option-${option.value}`">{{
                option.text
              }}</span>
            </template>
          </v-select>

          <v-select
            class="col-md-3 my-3"
            multiple
            name="extraPatientFilters"
            :options="patientSearchOptions.extraPatientFilters"
            :model-value="selectedExtraPatientFiltersList"
            label="text"
            :placeholder="trans('patient.patientsMessageFiltersPlaceholder')"
            @update:model-value="selectExtraPatientFilters($event)"
          />

          <form class="col my-3 input-group" @submit.prevent="getResults(1)">
            <input
              id="search-field"
              v-model="searchFields.query"
              data-test="patients-search-field"
              type="text"
              class="form-control"
              :placeholder="trans('patient.patientsSearchFieldPlaceholder')"
            />

            <span class="input-group-btn pl-4">
              <button
                v-if="isSearching"
                class="btn btn-danger mr-2"
                type="button"
                @click.stop="clearSearch"
              >
                <span>{{ trans("general.clearSearch") }}</span>
                <i class="fal fa-times" />
              </button>
              <button
                class="btn btn-primary"
                type="button"
                data-test="patients-search-submit"
                @click.stop="getResults(1)"
              >
                <span>{{ trans("general.search") }}</span>
                <i class="far fa-search" />
              </button>
            </span>
          </form>
        </div>
      </div>

      <patients-advanced-search-fields
        v-if="isAdvancedSearchOpen"
        :search-options="patientSearchOptions"
        :search-fields="searchFields"
        :options-loading="optionsLoading"
      />

      <div class="clearfix" />
      <div class="filter-links">
        <span class="float-right pb-2">
          <a class="advanced-btn" @click="toggleAdvancedSearch">
            {{ trans("evaluation.advancedShow") }}
            <i
              class="far fa-angle-down"
              :class="[
                isAdvancedSearchOpen ? 'fa-angle-up' : 'fa-angle-down',
                'far',
              ]"
            />
          </a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PatientsAdvancedSearchFields from "./PatientsAdvancedSearchFields.vue";

export default {
  components: {
    PatientsAdvancedSearchFields,
  },
  props: {
    loading: Boolean,
    optionsLoading: Boolean,
    patientSearchOptions: {
      patientFilters: Array,
      extraPatientFilters: Array,
      products: Array,
      centers: Array,
      userActivity: Array,
      users: Array,
      statuses: Array,
    },
    searchFields: Object,
  },
  data() {
    return {
      isSearching: false,
      isAdvancedSearchOpen: false,
      selectedExtraFilters: null,
      selectedExtraPatientFiltersList: null,
    };
  },
  watch: {
    patientSearchOptions: [
      {
        handler: "getProps",
      },
    ],
  },
  methods: {
    getResults: function (page) {
      this.setQueryFields();
      this.$emit("getPatientSearchResults", page);
    },
    selectExtraPatientFilters: function (filtersList) {
      const oldSelectedExtraFilters = this.selectedExtraFilters;

      this.selectedExtraFilters = filtersList;

      const newSelectedExtraFilters = this.selectedExtraFilters;

      this.selectedExtraPatientFiltersList = filtersList;

      oldSelectedExtraFilters.forEach((el) => {
        if (
          newSelectedExtraFilters.length !== 0 &&
          newSelectedExtraFilters.includes(el.value)
        ) {
          return;
        } else {
          // if element is not in the new list, assign ""
          this.searchFields[el.value] = "";
        }
      });

      // assign 1 to all elements in the new list
      newSelectedExtraFilters.forEach((element) => {
        this.searchFields[element.value] = 1;
      });

      this.getResults(1);
    },
    clearSearch: function () {
      this.isSearching = false;
      this.isAdvancedSearchOpen = false;

      this.$emit("clearSearch");
    },
    toggleAdvancedSearch: function () {
      this.isAdvancedSearchOpen
        ? (this.isAdvancedSearchOpen = false)
        : (this.isAdvancedSearchOpen = true);
    },
    setQueryFields: function () {
      // advanced search and clear button should not be visible if one of the values triggering them gets cleared
      this.isAdvancedSearchOpen = false;
      this.isSearching = false;

      // assign extra filter values after page refresh
      let list = [];
      if (this.patientSearchOptions.extraPatientFilters.length !== 0) {
        for (let key in this.searchFields) {
          this.patientSearchOptions.extraPatientFilters.find((e) => {
            if (e.value === key && this.searchFields[key] == 1) {
              list.push(e);
            }
          });
        }
        this.selectedExtraPatientFiltersList = list;
        this.selectedExtraFilters = list;
      }

      for (let key in this.searchFields) {
        let value = this.searchFields[key];
        const hasValue = Array.isArray(value)
          ? value.length > 0
          : value && value !== "";
        if (
          hasValue &&
          inArray(key, [
            "query",
            "products",
            "center",
            "userType",
            "user",
            "status",
          ])
        ) {
          this.isAdvancedSearchOpen = true;
          this.isSearching = true;
        }
      }
    },
    getProps: function (el) {
      this.setQueryFields();
    },
  },
};
</script>

<style scoped>
.filter-search-bar,
.advanced-search {
  background-color: #f5f5f5;
}

.advanced-search {
  padding-top: 0px;
}
</style>
